import cx from 'classnames';

type OwnProps = {
  goToPage?: any;
  primaryButton?: any;
  secondaryButton?: any;
  backgroundButton?: any;
  light?: boolean;
  text?: any;
  isMobile?: boolean;
  visible?: boolean;
  textButton?: boolean;
  isButtonCapitalized?: any;
};

export default function CTButton({
  goToPage,
  primaryButton,
  secondaryButton,
  backgroundButton,
  light = false,
  text,
  isMobile = false,
  visible = true,
  textButton = false,
  isButtonCapitalized
}: OwnProps) {
  const getMobileText = () => {
    const lowerCase = text.toLowerCase();

    return lowerCase.replace(lowerCase[0], text[0]);
  };

  return (
    <button
      onClick={goToPage}
      className={cx('ct-button-revamp', {
        light,
        mobile: isMobile,
        visible,
        'btn-primary-ghost': primaryButton,
        'btn-secondary-ghost': secondaryButton,
        'btn-background-ghost': backgroundButton,
        capitalize: isButtonCapitalized,
        'ct-text-button': textButton
      })}
      data-analytics-id="conditional-tile-revamp-button"
      type="button"
    >
      {isMobile ? getMobileText() : text}
    </button>
  );
}
